<app-leveltwo [pageId]="2">
  <div class="General">

      <h3>{{'HospitalProperty.PageTitle'|translate}}</h3>

      <p>{{'HospitalProperty.Hospitalpropertymust'|translate}}</p>

      <p>{{'HospitalProperty.Hospitalpropertyissujbject'|translate}} <a href="#">{{'HospitalProperty.section214'|translate}}</a> {{'HospitalProperty.Thoseportions'|translate}} </p>

      <p>{{'HospitalProperty.Withincertain'|translate}}</p>




  </div>
</app-leveltwo>
